import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'giq-small-load',
    templateUrl: 'small-load.component.html',
    styleUrls: ['small-load.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SmallLoadComponent {

}